import { getdata, savadata } from "../../utils/localstorage"
import * as types from "./actionType"
const initialstate={
    isAuth:getdata("token") ? true : false,
    token:getdata("token") || "",
    isLoading:false,
    isError:false
}

const reducer=(state=initialstate,action)=>{
    const{type,payload}=action
    switch(type){
        case types.REGISTER_REQUEST:
            return {...state,isLoading:true}
        case types.REGISTER_SUCCESS:
            return {...state,isLoading:false}
        case types.REGISTER_FAILURE:
            return {...state,isLoading:false,isError:true}

        case types.LOGIN_REQUEST:
            return {...state,isLoading:true}
        case types.LOGIN_SUCCESS:
            savadata("token",payload)
            return {...state,isLoading:false,isAuth:true,token:payload}
        case types.LOGIN_FAILURE:
            return {...state,isLoading:false,isError:true,isAuth:false,token:""}
        default:
            return state
    }
}

export {reducer}